import React from 'react';
import useStyles from 'apps/Pdf/components/common/styles/Spacer';

interface Props {
  variant?: 'quarter' | 'half';
}

const Spacer = (props: Props) => {
  const classes = useStyles();
  const variantClass = props.variant ? classes[props.variant] : '';

  return <div className={`${classes.root} ${variantClass}`}>&nbsp;</div>;
};

export default Spacer;
